<template>
  <div
    v-if="isExpanded"
    class="sidebar-view"
    ref="appDrawer"
    :md-active="visible"
    @close="$emit('close')"
  >
    <md-toolbar class="md-transparent" md-elevation="0">
      {{ title }}
    </md-toolbar>

    <div
      v-if="commonActions && commonActions.length"
      class="common-actions"
    >
      <md-button
        v-for="action in commonActions"
        :key="action.key"
        @click.native="onCommonAction(action.key)"
      >
        {{ action.name }}
      </md-button>
    </div>

    <md-list>
      <md-list-item
        v-for="item in list"
        :key="item[itemKeyField]"
      >
        <div class="md-list-text-container">
          <span>{{ item.name }}</span>
        </div>
        <md-button
          v-for="action in itemActions"
          :key="action.key"
          class="md-icon-button md-list-action"
          @click.native="onItemAction(action.key, item)"
        >
          <md-icon>
            {{ action.icon }}
          </md-icon>
          <md-tooltip v-if="action.name">
            {{ action.name }}
          </md-tooltip>
        </md-button>
      </md-list-item>
    </md-list>
  </div>
</template>

<script>
import Expandable from '@/mixins/Expandable.js'
export default {
  mixins: [Expandable],
  props: {
    visible: Boolean,
    title: String,
    list: Array,
    itemActions: Array,
    commonActions: Array,
    itemKeyField: String
  },
  methods: {
    onCommonAction (actionKey) {
      this.$emit('common-action', actionKey)
    },
    onItemAction (actionKey, item) {
      this.$emit('item-action', actionKey, item)
    }
  }
}
</script>

<style lang="sass">
.sidebar-view
  position: fixed
  width: 400px
  left: 0px
  top: 0px
  height: 100%
  background-color: white
  border-right: 1px solid gray
  z-index: 100
</style>


// WEBPACK FOOTER //
// SidebarView.vue?38910c6f